import React, {useState, useRef} from 'react';
import _ from 'lodash';
import CheckableTag from './tag/checkable-tag';
import useClickOutside from '../hooks/click-outside';

import K from '../k';

const SearchBar = ({style, wrapperStyle, filterContainerStyle, filters, placeholder, onFilterChange, onChange, onSearchInput}) => {
  const hasFilters = !_.isEmpty(filters);
  const containerRef = useRef(null);
  const [isExpanded, setIsExpanded] = hasFilters ? useState(false) : [false, null];
  const [searchTerm, setSearchTerm] = useState();
  const handleClose = () => setIsExpanded(false);

  if (hasFilters) useClickOutside(containerRef, handleClose);

  const styles = {
    wrapper: {
      position: 'relative',
      ...wrapperStyle
    },
    input: {
      width: '100%',
      height: 40,
      border: 'none',
      ...style
    },
    filtersContainer: {
      position: 'absolute',
      top: 40,
      zIndex: 3,
      backgroundColor: K.colors.base,
      display: 'flex',
      flexDirection: 'column',
      padding: K.spacing,
      borderRadius: '0 0 5px 5px',
      border: '1px solid black',
      borderTop: 'none',
      width: '100%',
      maxHeight: '75vh',
      overflowY: 'auto',
      ...K.shadow,
      ...filterContainerStyle
    },
    checkableTagsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      gap: K.spacing / 2,
    },
    filter: {marginBottom: K.spacing},
    filterLabel: {fontWeight: 'bold', marginLeft: K.spacing - 9, marginBottom: K.spacing / 2},
    checkableTag: {paddingVertical: 3, paddingHorizontal: 6, cursor: 'pointer'},
    tagLabel: (checked) => ({color: checked ? 'white' : 'black'}),
  };

  const handleInputFocus = () => hasFilters && setIsExpanded(true);

  const handleSearchInput = (e) => {
    setSearchTerm(e.target.value);

    if (onSearchInput) onSearchInput(e);
  };

  const handleSearchChange = (e) => {
    if (onChange) onChange(e);
  };

  if (filters) {
    //TODO use henrybuilt js lib lib.string.isSearchMatch({title: addItem.title, input: this.state.searchTerm, distance: 0, matchPlurals: true})
    filters = _.map(filters, filter => {
      return {
        ...filter,
        options: _.filter(filter.options, option => _.includes(_.toLower(option.label), _.toLower(searchTerm)))
      };
    });

    filters = _.filter(filters, filter => _.get(filter, 'options.length') > 0);
  }

  return (
    <div ref={containerRef} style={styles.wrapper}>
      <input
        onFocus={handleInputFocus}
        onInput={handleSearchInput}
        onChange={handleSearchChange}
        type='text'
        style={styles.input}
        placeholder={placeholder || 'Search...'}/>
      {isExpanded && <div style={styles.filtersContainer}>
        {_.map(filters, ({key: filterKey, options, label: filterLabel, activeOptions}) => {
          return (
            <div key={filterKey} style={styles.filter}>
              <div style={styles.filterLabel}>{filterLabel}</div>
              <div style={styles.checkableTagsContainer}>
                {_.map(options, ({value, label}) => {
                  const checked = _.includes(activeOptions, value);
                  return (
                    <CheckableTag
                      style={styles.checkableTag}
                      onChange={() => onFilterChange && onFilterChange({key: filterKey, value})}
                      checked={checked}
                      color={checked ? 'black' : undefined}
                      key={`${filterKey}-${value}`}>
                      <span style={styles.tagLabel(checked)}>{label}</span>
                    </CheckableTag>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>}
    </div>
  );
};

export default SearchBar;